var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tarid" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", {
      staticClass: "info pt-4",
      domProps: { innerHTML: _vm._s(_vm.article.text) },
    }),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex flex-start w-100" }, [
      _c("div", { staticClass: "mr-2 hidden-md-down" }, [
        _c("span", { staticClass: "icon-stack icon-stack-lg" }, [
          _c("i", {
            staticClass:
              "base base-6 icon-stack-3x opacity-100 color-primary-500",
          }),
          _vm._v(" "),
          _c("i", {
            staticClass: "ni ni-phone icon-stack-1x opacity-100 color-white",
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-fill" }, [
        _c("div", { staticClass: "flex-fill" }, [
          _c("span", { staticClass: "h5" }, [_vm._v("Тарифи Київстар")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }